angular.module('gym.components').directive('waiverWalletDetailsPrivacyPolicySection', function() {
  return {
    restrict: 'EA',
    scope: {
      waiver: '=',
      privacyPolicies: '=',
      readOnly: '='
    },
    template: require('templates/components/waivers/waiver_wallet_details_privacy_policy_section.html.slim'),
    controller: ["$scope", function($scope) {}]
  };
});
